import { HTMLProps, useEffect, useRef } from 'react';
import { Input } from '../input';

export const TableCheckBox = ({
  indeterminate,
  enableMultiRowSelection = true,
  className = '',
  ...rest
}: {
  indeterminate?: boolean;
  enableMultiRowSelection?: boolean;
} & HTMLProps<HTMLInputElement>) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <div
      className="flex h-full w-full items-center justify-center p-2"
      onClick={(e) => e.stopPropagation()}
    >
      <Input
        {...rest}
        ref={ref}
        type={enableMultiRowSelection ? 'checkbox' : 'radio'}
        className={className + ' cursor-pointer outline-none focus:ring-0'}
      />
    </div>
  );
};
